import { useEffect } from "react";

function useDocumentTitle(title, metaDescription) {
  useEffect(() => {
    document.title = title;

    if (metaDescription) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = metaDescription;
    }
  }, [title, metaDescription]);
}

export default useDocumentTitle;
